(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('InfoModalBoothSetupController', InfoModalBoothSetupController);

    InfoModalBoothSetupController.$inject = ['$uibModalInstance', 'boothItem', 'VirtualFairService', '$rootScope','$scope', '$sce'];

    function InfoModalBoothSetupController($uibModalInstance, boothItem, VirtualFairService, $rootScope, $scope, $sce) {
        var vm = this;

        vm.boothItem       = boothItem;
        vm.registered      = '';
        vm.query           = [];
        vm.photos          = [];
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.getPhotos       = getPhotos;

        activate();

        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        }

        function activate() {

        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function getPhotos(album) {
            album.toggle = !album.toggle;
            if(typeof album.check === 'undefined') {
                VirtualFairService.getPhotos(album).then(function(response){
                    album.photos = response.data;
                    album.check = true;

                }).catch(function(err) {
                    alertify.notify(err, 'danger', 3);
                });
            }
        }

    }

})();